import { useQuery } from '@tanstack/react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { getAutom8tlyUrl } from 'services/autom8tly/autom8tly';
import { AUTOM8TLY_KEY } from '../constants';

export function useGetAutom8tlyUrl() {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr: number = globalStoreData.user?.profileDTO?.corpAcctNbr;

  const ssoToken = globalStoreData?.sso;
  return useQuery([AUTOM8TLY_KEY], {
    queryFn: () => getAutom8tlyUrl(corpAcctNbr, ssoToken),
    select: (data) => {
      const {
        autom8tlyBaseUrl,
        jwtToken,
        partnerId,
        tenantId,
        userUuid,
      } = data;
      return {
        autom8tlyBaseUrl: `${autom8tlyBaseUrl}/campaign-builder?tenant_id=${corpAcctNbr}&userUUID=${userUuid}&source=nextiva`,
        jwtToken,
        partnerId,
        tenantId,
        userUuid,
      };
    },
    enabled: !!corpAcctNbr,
    onError: (e) => {
      // eslint-disable-next-line no-console
      console.error('Error in useGetAutom8tlyUrl', e);
    },
  });
}
